export const BACKEND_URL = 'https://up.cmcit.ro';   // http://up.cmcit.ro:3000
export const FRONTEND_URL = 'https://up.cmcit.ro'; // https://up.cmcit.ro:3000

export const CAPTCHA_SITE_KEY = "6Lcy_2wrAAAAAIjUpRvgBPgcIyEdWVNlCXym3yOr";
